import React, { Component }  from 'react';
import { TestConstants }     from './environment';
import { isInRoleFromToken } from '../../../utils/authService';

class TestBreadcrumb extends Component {

  render() {
    if (isInRoleFromToken(TestConstants.AdminRole)) {
      return (
        <div className="c-breadcrumbs__wrapper" >
          <ul className="c-breadcrumbs">
            <li className="c-breadcrumbs__item">
              <a href={TestConstants.AdminHashPrefix + '/initiative'} className="anchor c-breadcrumbs__anchor" >
                Create Test Initiative
              </a>
            </li>
          </ul>
        </div>
      );
    }
    else if (TestConstants.UserRole === "*" || isInRoleFromToken(TestConstants.UserRole)) {
      return (
        <div className="c-breadcrumbs__wrapper" >
          <ul className="c-breadcrumbs">
            <li className="c-breadcrumbs__item">
              <a href={TestConstants.UserHashPrefix} className="anchor c-breadcrumbs__anchor" >
                Retrieve Password
              </a>
            </li>
            <li className="c-breadcrumbs__item">
              <a href={TestConstants.UserHashPrefix + '/initiative'} className="anchor c-breadcrumbs__anchor" >
                Create Test Initiative
              </a>
            </li>
            <li className="c-breadcrumbs__item">
              <a href={TestConstants.UserHashPrefix + '/untouchables'} className="anchor c-breadcrumbs__anchor" >
                View Untouchables
              </a>
            </li>
          </ul>
        </div>
      );
    }
    else {
      // Not logged in or wrong role
    }
  }
}

export default TestBreadcrumb;